import headerView from '../../components/header'
import BackToTop from 'vue-backtotop'

export default {
  components: {
    headerView,
    BackToTop
  },
  created () {
    this.checkUser()
  },
  mounted () {
    if (this.$route.meta.group_id !== 3) {
      sessionStorage.invoiceActivePage = 1
      sessionStorage.invoiceActiveMonth = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/full.js